<template>
  <div class="container">
    <HMModalHeader
      :title="$t('COMMUNITY.TITLE.NEW_MESSAGE')"
      @close="$emit('close')"
    />
    <div
      class="options-container d-flex flex-row flex-wrap align-items-center justify-content-center w-100 pt-3 pb-4"
    >
      <section
        class="option-container d-flex flex-column align-items-center justify-content-between border rounded p-5 pointer"
        @click="sendNewDirectMessage"
      >
        <span
          class="icon d-flex align-items-center justify-content-center mb-2"
        >
          <i class="fa fa-send c-brand-color"></i>
        </span>
        <p>{{ $t('COMMUNITY.LABEL.SEND_A_DIRECT_MESSAGE') }}</p>
      </section>
      <div class="d-none d-md-block p-2"></div>
      <div class="d-block d-md-none my-2 w-100"></div>
      <section
        class="option-container d-flex flex-column align-items-center justify-content-between border rounded p-5 pointer"
        @click="sendNewGroupMessage"
      >
        <span
          class="icon d-flex align-items-center justify-content-center mb-2"
        >
          <i class="fa fa-comments-alt c-brand-color"></i>
        </span>
        <p>{{ $t('COMMUNITY.LABEL.CREATE_A_NEW_CHAT_ROOM') }}</p>
      </section>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'CommunityNewChatModal',
  props: {
    onSendNewDirectMessage: null,
    onSendNewGroupMessage: null,
  },
  methods: {
    sendNewDirectMessage() {
      this.onSendNewDirectMessage();
      this.$emit('close');
    },
    sendNewGroupMessage() {
      this.onSendNewGroupMessage();
      this.$emit('close');
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.option-container {
  min-width: 300px;
  &:hover {
    background: $light-gray;
  }

  .icon {
    background-color: var(--brand-color-with-opacity-03, $coral);
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
  }
}
</style>
